import { render, staticRenderFns } from "./partners-view.vue?vue&type=template&id=0130fc65&scoped=true"
import script from "./partners-view.vue?vue&type=script&lang=js"
export * from "./partners-view.vue?vue&type=script&lang=js"
import style0 from "./partners-view.vue?vue&type=style&index=0&id=0130fc65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0130fc65",
  null
  
)

export default component.exports